export const REQUEST_USER_START = 'REQUEST_USER_START';
export const REQUEST_USER_SUCCESS = 'REQUEST_USER_SUCCESS';
export const REQUEST_USER_ERROR = 'REQUEST_USER_ERROR';
export const REQUEST_USER_RELOAD = 'REQUEST_USER_RELOAD';
export const RELOAD_USER_START = 'RELOAD_USER_START';
export const SET_SHORT_USER_DATA = 'SET_SHORT_USER_DATA';
